/**
 * Admin users API endpoints.
 */

import { http } from './http';
import type { AdminUser, PaginatedResponse, User, UserFilters } from './types';

/** GET /api/v1/admin/users */
export async function listUsers(filters?: UserFilters): Promise<PaginatedResponse<User>> {
  const params = new URLSearchParams();
  if (filters?.search) params.set('search', filters.search);
  if (filters?.status) params.set('status', filters.status);
  if (filters?.cursor) params.set('cursor', filters.cursor);
  if (filters?.limit) params.set('limit', String(filters.limit));
  if (filters?.created_after) params.set('created_after', filters.created_after);
  if (filters?.created_before) params.set('created_before', filters.created_before);

  const query = params.toString();
  return http.get(`/admin/users${query ? `?${query}` : ''}`);
}

/** GET /api/v1/admin/users/:id */
export async function getUser(id: string): Promise<{ user: User }> {
  return http.get(`/admin/users/${id}`);
}

/** PATCH /api/v1/admin/users/:id */
export async function updateUser(
  id: string,
  data: { status?: string; username?: string },
): Promise<{ user: User }> {
  return http.patch(`/admin/users/${id}`, data);
}

/** DELETE /api/v1/admin/users/:id */
export async function deleteUser(id: string): Promise<void> {
  await http.delete(`/admin/users/${id}`);
}

/** GET /api/v1/admin/admin-users */
export async function listAdminUsers(): Promise<{ data: AdminUser[] }> {
  return http.get('/admin/admin-users');
}

/** POST /api/v1/admin/admin-users */
export async function createAdminUser(data: {
  user_id: string;
  role: string;
}): Promise<{ admin: AdminUser }> {
  return http.post('/admin/admin-users', data);
}

/** PATCH /api/v1/admin/admin-users/:id */
export async function updateAdminUser(
  id: string,
  data: { role?: string; status?: string },
): Promise<{ admin: AdminUser }> {
  return http.patch(`/admin/admin-users/${id}`, data);
}

/** DELETE /api/v1/admin/admin-users/:id */
export async function deleteAdminUser(id: string): Promise<void> {
  await http.delete(`/admin/admin-users/${id}`);
}
